import React from "react";
// import { decodeToken } from "react-jwt";
import { Navigate } from "react-router-dom";
import { useLoginContextSU } from "../context/loginContextSU";
import { role, menuListSU } from "../utils/globalVariables";
import { safetyDecodeJWT } from "../utils/globalFunctions";
import LoginIndexSuperUser from "../pages/superuser/LoginIndexSuperUser";

const LoginRouteSU = () => {

    const { loginContextSU } = useLoginContextSU();

    try {
        if (safetyDecodeJWT(loginContextSU, 'syswebapp', 'syswebappsl') === role.super_user.subLevel.super_user.slugSubLevel) {
            return <Navigate
                to={`/${role.super_user.subLevel.super_user.slugLink}/${menuListSU.subMenu.one.tabs.one.flag}`}
                replace={true}
            />
        } else {
            return <LoginIndexSuperUser />;
        }
    } catch (error) {
        return <LoginIndexSuperUser />;
    }
}

export default LoginRouteSU;